<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <v-form @submit.prevent="handleSubmit">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-widget title="اطلاعات درگاه">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            <v-text-field
                                                    label="نام نمایشی"
                                                    name="name"
                                                    v-model="form.name"
                                                    type="text"
                                                    maxlength="255"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex style="position: relative">
                                            <div style="position:absolute;left:1px;top:1px">
                                                <v-btn icon @click="changeToken">
                                                    <v-icon style="color:blue">update</v-icon>
                                                </v-btn>
                                            </div>
                                            <v-text-field
                                                    label="توکن"
                                                    name="token"
                                                    v-model="form.token"
                                                    type="text"
                                                    data-ltr
                                                    readonly
                                                    maxlength="35"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>

                                        <v-flex>
                                            <v-text-field
                                                    label="IP مجاز (اختیاری)"
                                                    name="ip"
                                                    v-model="form.ip"
                                                    type="text"
                                                    data-ltr
                                                    maxlength="45"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex>
                                            <v-autocomplete
                                                    label="فروشگاه"
                                                    disabled
                                                    :items="stores"
                                                    v-model="form.store_id"
                                                    autocomplete
                                                    auto
                                                    required
                                                    item-text="shop_name"
                                                    item-value="shop_id"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                @click.native="handleSubmit"
                                                :disabled="loading"
                                                color="blue"
                                                class="white--text"
                                                large
                                                type="submit"
                                        >
                                            ذخــیره
                                            &nbsp;
                                            <v-icon left dark>save</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import Crypto from 'crypto-js';
export default {
  components: {
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      form: {
        ip: '',
        name: '',
        token: '',
        api_id: 0,
        store_id: 0,
      },
      stores: [],
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {},
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    }
  },
  mounted: function () {
    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    this.axios.get('/reseller/api/?api_id=' + this.$route.params.id)
      .then(response => {
        this.form = response.data.data[0];
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    changeToken () {
      this.form.token = String(Crypto.MD5(String(Math.random()))).toUpperCase();
    },
    handleSubmit () {
      this.loading = true;
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.axios.put('/reseller/api/' + this.$route.params.id, this.form)
            .then(response => {
              // Response Submit Method
              console.log(response);
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
              setTimeout(() => {
                this.$router.push('/pages/api/modify');
              }, 2000);
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
              this.loading = false;
            });
        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/api/edit.vue